import { takeEvery } from 'redux-saga/effects';

import sagaReconnected, { action as sagaReconnectedAction } from './sagaReconnected';

export default () => {
  return function* () {
    yield takeEvery(sagaReconnectedAction, sagaReconnected);
  };
};
